import useShallowMemo from 'use-shallow-memo';
import useInit from './use-init.js';
import useSessionReplayRecording from './use-session-replay-recording.js';
import useUser from './use-user.js';
export default function useDatadog({ enabled = true, sessionReplayRecording = true, silentMultipleInit = true, site = 'datadoghq.com', user, ...rumInitConfiguration }) {
    useInit({
        enabled,
        rumInitConfiguration: useShallowMemo({
            ...rumInitConfiguration,
            silentMultipleInit,
            site,
        }),
    });
    useSessionReplayRecording({
        enabled,
        sessionReplayRecording,
    });
    useUser(user);
}
//# sourceMappingURL=use-datadog.js.map